import React from 'react';
import {
  GalleryGrid,
  TemplateCardListItems as LibraryTemplateCardListItems,
} from '@wix/wix-studio-marketplace-lib';
import { TemplateListCardComponentProps } from '@wix/wix-studio-marketplace-lib/dist/types/components/TemplateGallery/TemplateCardListItems/TemplateCardListItems';
import TemplatesLoadingState from '../TemplatesLoadingState';
import WrappedTemplateCard from '../WrappedTemplateCard';
import clsx from 'clsx';
import s from '../ProfileTemplates.module.scss';
interface LoadingTemplateGalleryProps {
  isMobileView: boolean;
  shouldShowThreeInRow?: boolean;
}

const LoadingTemplateGallery: React.FC<LoadingTemplateGalleryProps> = ({
  isMobileView,
  shouldShowThreeInRow = false,
}) => {
  const wrappedLoadingTemplateCardWithProps = (
    props: TemplateListCardComponentProps,
  ) => (
    <WrappedTemplateCard
      {...props}
      logTemplateClick={() => {}}
      isMobileView={isMobileView}
    />
  );

  return (
    <GalleryGrid
      listGridClassOverride={clsx(
        s.galleryGridList,
        shouldShowThreeInRow && s.threeInRow,
      )}
      content={
        <LibraryTemplateCardListItems
          CardComponent={wrappedLoadingTemplateCardWithProps}
          LoadingState={() => (
            <TemplatesLoadingState isMobileView={isMobileView} />
          )}
          templates={[]}
          isMobileView={isMobileView}
          SSRFlow={false}
        />
      }
    />
  );
};

export default LoadingTemplateGallery;
